import * as z from "zod";

const linnworksReturnsLocationTargetSchema = z.object({
  linnworksLocationId: z.string().trim().min(1),
  linnworksLocationName: z.string().trim().optional(),
  binrack: z.string().trim().min(1),
});

export const linnworksReturnsSettingsSchema = z.object({
  enabled: z.boolean(),
  processReturnsEnabled: z.boolean(),
  defaultLocation: linnworksReturnsLocationTargetSchema.optional(),
  mappings: z.array(
    linnworksReturnsLocationTargetSchema.extend({
      redoLocationId: z.string().trim().min(1),
    }),
  ),
});
